import { InjectionToken } from '@angular/core';
import { CommentDto, UpdateAssetCommentBody } from '@picflow/types';
import { Observable } from 'rxjs';

export interface PicflowComments {
  getComments(assetId: string, galleryId: string): Observable<CommentDto[]>;
  updateComment(
    assetId: string,
    commentId: string,
    params: UpdateAssetCommentBody,
    galleryId: string
  ): Observable<CommentDto>;
}

export const PICFLOW_COMMENTS = new InjectionToken<PicflowComments>('picflowComments');
